const preferenceThemes = ['default', 'light', 'dark', 'accessible'] as const;

const preferencePageSizes = [5, 10, 30, 50, 100] as const;

const preferenceLanguages = ['en'] as const;

type PreferenceTheme = (typeof preferenceThemes)[number];

type PreferencePageSize = (typeof preferencePageSizes)[number];

type PreferenceLanguage = (typeof preferenceLanguages)[number];

/** A widget's place in a dashboard row: which widget, and how many of the row's columns it covers. */
type DashboardWidgetPlacement = {
  key: string;
  span: number;
};

const defaultPreferences = {
  fullWidth: true,
  theme: 'default' as PreferenceTheme,
  language: 'en' as PreferenceLanguage,
  pageSize: 30 as PreferencePageSize,
  dashboardHiddenWidgets: {} as Record<string, string[]>,
  dashboardWidgetLayout: {} as Record<string, DashboardWidgetPlacement[][]>,
  tableStates: {} as Record<string, unknown>,
  shortcuts: [] as string[],
};

export { defaultPreferences };
export { preferenceLanguages };
export { preferencePageSizes };
export { preferenceThemes };

export type { DashboardWidgetPlacement };
export type { PreferenceLanguage };
export type { PreferencePageSize };
export type { PreferenceTheme };
